<template>
  <div class="user">

    <template v-if="!userData">
      <div class="columns">
        <div class="column">
          <h1 class="title is-4">Loading <i class="fas fa-cog fa-spin"></i></h1>
        </div>
      </div>
    </template>

    <template v-else>
      <div class="columns">
        <div class="column">
          <h1 class="title is-3">
            <span v-if="!userData.active" class="has-text-danger">DISABLED</span>
            {{ userData.firstName }} {{ userData.lastName }}
            <span class="tag is-info is-clickable margin-left" @click="goBack">Back</span>
          </h1>
        </div>
      </div>

      <!-- EDIT DETAILS -->
      <template v-if="editUserData">
        <user-form
          :user="editUserData"
          :loading="loading"
          :show-cancel="true"
          :err-msg="errMsg"
          @submit-user="updateUser"
          @disable-user="disableUser"
          @cancel="editUserData = null" />
      </template>

      <!-- ADD DOC -->
       <template v-else-if="addDoc">
        <div class="columns">
          <div class="column">
            <h1 class="title is-4">Add New Profile Document</h1>
          </div>
        </div>
        <profile-document-form
          :user="userData"
          :show-cancel="true"
          @submitted="docSubmited"
          @cancel="addDoc = false">
        </profile-document-form>
      </template>

      <!-- VIEW DOC -->
       <template v-else-if="selectedDoc && !editDoc">
        <div class="columns">
          <div class="column">
            <h1 class="title is-4">Profile Document</h1>
          </div>
        </div>
        <div class="columns">
          <div class="column">
            <profile-document :doc="selectedDoc"></profile-document>
          </div>
        </div>
        <div class="columns">
          <div class="column">
            <div class="buttons">
              <button class="button" @click="selectedDoc = null">Close</button>
              <button class="button is-info" @click="editDoc = true">Edit</button>
            </div>
          </div>
        </div>
      </template>

       <!-- EDIT DOC -->
       <template v-else-if="selectedDoc && editDoc">
        <div class="columns">
          <div class="column flex">
            <h1 class="flex-1 title is-4">Edit Profile Document</h1>
          </div>
        </div>
        <profile-document-form
          :user="userData"
          :doc="selectedDoc"
          :show-cancel="true"
          @submitted="docSubmited"
          @cancel="editDoc = false">
        </profile-document-form>
      </template>

      <!-- SHOW UESR  -->
      <template v-else>
        <div class="columns">
          <div class="column">
            <user-details :user="userData"></user-details>
            <br />
            <button v-if="userData.active" class="button is-info" @click="editUser">Edit Details</button>
            <button v-else class="button is-warning" :class="{'is-loading': loading === 'enabling'}" @click="enableUser(userData)">Enable User</button>
          </div>
        </div>
        <div class="columns">
          <div class="column">
            <div class="box">
              <div class="flex">
                <h1 class="flex-1 title is-4">Profile Documents</h1>
                <div v-if="userData.active">
                  <button class="button is-success" @click="addDoc = true"><i class="fas fa-plus"></i></button>
                </div>
              </div>
              <b-table v-if="!selectedDoc"
                :data="documents"
                :bordered="false"
                :hoverable="true"
                :loading="!documents"
                :selected.sync="selectedDoc">
                <template slot-scope="props">
                  <b-table-column field="name" label="name">{{ props.row.name }}</b-table-column>
                  <b-table-column field="issuedDate" label="Issued Date" centered>{{ formatDate(props.row.dateIssued) }}</b-table-column>
                  <b-table-column field="expiryDate" label="Expiry Date" centered>{{ formatDate(props.row.dateExpire) }}</b-table-column>
                </template>
                <template slot="empty">
                  <section class="section">
                    <div class="content has-text-grey has-text-centered">
                      <p>NO DOCUMENTS</p>
                    </div>
                  </section>
                </template>
              </b-table>
            </div>
          </div>
        </div>
      </template>

    </template>

  </div>
</template>

<style>
.privs span::after {
  content: ', '
}
.privs span:last-child::after {
  content: ''
}
</style>

<script>
import UserForm from '../../components/UserForm'
import UserDetails from '../../components/UserDetails'
import ProfileDocument from '../../components/ProfileDocument'
import ProfileDocumentForm from '../../components/ProfileDocumentForm'
export default {
  name: 'User',
  components: {
    UserForm,
    UserDetails,
    ProfileDocument,
    ProfileDocumentForm
  },
  data () {
    return {
      uid: null,
      userData: null,
      editUserData: null,
      selectedDoc: null,
      documents: [],
      addDoc: false,
      editDoc: false,
      loading: false,
      fetchingUser: true,
      errMsg: ''
    }
  },
  created () {
    this.subs.users = this.$firestore.collection('users')
      .doc(this.$route.params.uid)
      .onSnapshot(snapshot => {
        this.userData = this.$utils.snapshotToObj(snapshot)
      })
    this.subs.profileDocuments = this.$firestore.collection('profile-documents')
      .where('uid', '==', this.$route.params.uid)
      .onSnapshot(snapshot => {
        this.documents = this.$utils.snapshotToArr(snapshot)
      })
  },
  methods: {
    goBack () {
      this.$router.push({ path: '/admin/users' })
    },
    editUser () {
      let editUserData = {}
      for (let k in this.userData) {
        if (k !== '_id') {
          editUserData[k] = this.userData[k]
        }
      }
      this.editUserData = editUserData
    },
    updateUser (user) {
      this.errMsg = ''
      this.loading = 'submitting'
      let updatedValues = {
        uid: this.userData.uid
      }
      for (let k in user) {
        if (this.userData[k] !== user[k]) {
          if (k === 'username') {
            updatedValues.email = this.$utils.usernameToEmail(user.username)
          }
          updatedValues[k] = user[k]
        }
      }
      updatedValues.emergencyContacts = user.emergencyContacts
      updatedValues.otherDetails = user.otherDetails
      this.$http
        .post(`${this.$store.getters.apiUrl}/update-user`, updatedValues)
        .then(resp => {
          console.log(resp.data)
          this.loading = false
          if (resp.data.status === 'error') {
            this.errMsg = resp.data.msg
          } else {
            this.$toast.open({
              message: 'User updated!',
              type: 'is-info'
            })
            this.loading = false
            this.editUserData = null
          }
        })
        .catch((err) => {
          this.loading = false
          // this.editUserData = null
          this.errMsg = 'ERROR ?'
          console.log('ERROR', err)
        })
    },
    async disableUser (user) {
      this.loading = 'disabling'
      try {
        const resp = await this.$http.post(`${this.$store.getters.apiUrl}/set-user-active`, {
          uid: user.uid,
          active: false
        })
        if (resp.data.status !== 'success') throw new Error(resp.data.msg)
        this.$toast.open({ message: 'USER DISABLED', type: 'is-info' })
        this.editUserData = null
      } catch (error) {
        this.$showError(error)
      }
      this.loading = false
    },
    async enableUser (user) {
      const confirmed = await this.$confirm({
        type: 'is-warning',
        title: 'Enable User',
        message: `Are you sure you want to enable user <p class="bold">${user.firstName} ${user.lastName}</p>`
      })
      if (!confirmed) return
      this.loading = 'enabling'
      try {
        const resp = await this.$http.post(`${this.$store.getters.apiUrl}/set-user-active`, {
          uid: user.uid,
          active: true
        })
        if (resp.data.status !== 'success') throw new Error(resp.data.msg)
        this.$toast.open({ message: 'USER ENABLED', type: 'is-info' })
      } catch (error) {
        this.$showError(error)
      }
      this.loading = false
    },
    docSubmited (doc) {
      this.addDoc = false
      this.editDoc = false
      this.selectedDoc = null
    },
    formatDate (unixTimestamp) {
      return unixTimestamp ? this.$moment.unix(unixTimestamp).format('DD/MM/YYYY') : '' + unixTimestamp
    }
  }
}
</script>
